import ExhibitElementModel from '../models/ExhibitElementModel';
import Collection from 'ampersand-collection';

export default Collection.extend({
	model: ExhibitElementModel,
	mainIndex: 'id'
});



// WEBPACK FOOTER //
// ./src/collections/ExhibitElementCollection.js